import { createContext, useCallback, useMemo, useState } from "react";
import DocumentUploadModal from "src/components/Modals/DocumentUploadModal";
import { useManageModal } from "src/hooks/useManageModal";

type ContextType = {
  openInsuranceUploadModal: (patientProfileId: string) => void;
};

export const PatientInsuranceModalContext = createContext<ContextType>({
  openInsuranceUploadModal: () => {},
});

interface Props {
  children: React.ReactNode;
}

const PatientInsuranceProvider = ({ children }: Props) => {
  const [patientProfileId, setPatientProfileId] = useState<string>("");
  const [open, { handleClose, handleOpen }] = useManageModal();

  const handleOpenInsuranceUploadModal = useCallback(
    (patientProfileId: string) => {
      setPatientProfileId(patientProfileId);
      handleOpen();
    },
    [handleOpen],
  );

  const handleCloseInsuranceModal = useCallback(() => {
    setPatientProfileId("");
    handleClose();
  }, [handleClose]);

  const value = useMemo(
    () => ({
      patientProfileId,
      openInsuranceUploadModal: handleOpenInsuranceUploadModal,
    }),
    [handleOpenInsuranceUploadModal, patientProfileId],
  );

  return (
    <PatientInsuranceModalContext.Provider value={value}>
      {children}
      <DocumentUploadModal
        open={open}
        onClose={handleCloseInsuranceModal}
        bucket="patients"
        folder="insurance"
        patientProfileId={patientProfileId}
      />
    </PatientInsuranceModalContext.Provider>
  );
};

export default PatientInsuranceProvider;
